import * as React from 'react';
import { SelectionTypeProps } from '../../types';
import { SelectionType } from '../../types-fields';
import { RadioSymbol } from 'ui';

type ActualValueComponentProps = SelectionTypeProps

class ActualValueComponent extends React.Component<ActualValueComponentProps, {}> {
  private handleOnChange = () => {
    this.props.onChange({
      fillEmpty: !!this.props.selectionField.value && this.props.selectionField.value.fillEmpty,
      type: SelectionType.ActualValue
    });
  };

  public render(): JSX.Element {
    const {
      selectionField: {
        value
      },
      selectionItem,
      checked
    } = this.props;
    
    const uniqueId = `actual-value-${this.props.selectionField?.selectionNo}`;

    return (<>
      <input 
        type="radio" 
        className="form-check-input visuallyhidden" 
        id={uniqueId}
        value={value.type}
        checked={checked}
        onChange={this.handleOnChange} 
      />
      <label
        className="form-check-label"
        htmlFor={uniqueId}>
        <RadioSymbol/>
        {selectionItem.label}
      </label>
    </>);
  }
}

export const ActualValue = ActualValueComponent;
